import { createContext, useContext } from 'react';

interface PipelineShellContextValue {
  setFailedCount: (count: number) => void;
}

export const PipelineShellContext = createContext<PipelineShellContextValue>({
  setFailedCount: () => {},
});

export const usePipelineShell = () => useContext(PipelineShellContext);
